/* eslint-disable key-spacing */
import { defaultSuggestionListTheme } from '../../src/SuggestionList/theme';

export const defaultMultiSelectTheme = {
  checkBoxItem:              'multiselect-check-box-item',
  checkBoxList:              'multiselect-checkbox-list',
  checkBoxListFooter:        'multiselect-footer',
  checkBoxListHeader:        'multiselect-header',
  checkBoxListWrapper:       'multiselect-checkbox-list-wrapper',
  checkBoxSemi:              'semi',
  checkBoxTreeList:          'checkboxtree-list',
  clearIcon:                 'multiselect-clear-icon',
  dropdownIcon:              'multiselect-dropdown-icon',
  dropdownIconClosed:        'closed',
  dropdownIconOpened:        'opened',
  input:                     'multiselect-input',
  inputFocused:              'focused',
  inputWrapper:              'multiselect-input-wrapper',
  inputWrapperDisabled:      'disabled',
  inputWrapperFocused:       'focused',
  inputWrapperInvalid:       'danger',
  inputWrapperRequired:      'required',
  loadingIcon:               'multiselect-loading-icon',
  placeholder:               'multiselect-placeholder',
  selectAll:                 'select-all',
  tagsContainer:             'multiselect-tags-container',
  tagsUnion:                 'multiselect-tags-union',
  wrapper:                   'multiselect-wrapper',
  /** SuggestionList theme */
  ...defaultSuggestionListTheme,
};
